import { RowScheduleDto } from "@/dtos";
import { Schedule } from "@/entities";

export const formatRowScheduleDto = (schedules: Schedule[]): RowScheduleDto[] => {
    return schedules.map((x) => {
        const row: RowScheduleDto = {
            ...x,
            active: (x.is_active) ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}